// extracted by mini-css-extract-plugin
export default {"fillColor":"IconSuccess_fillColor__1AqFI"};